import { Inject, Injectable } from '@angular/core';

import { MoneyService } from '@frontend/sports/common/core/feature/money';
import { Observable, of } from 'rxjs';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { BetslipError } from '../../../errors/betslip-error';
import { StakeNotDividablePreCheckError } from '../../../errors/pre-check/stake-not-dividable-pre-check-error';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class StakeNotDividableMessageFormatter extends MessageFormatter<StakeNotDividablePreCheckError> {
    private messages: IBetslipMessages;
    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        private moneyService: MoneyService,
    ) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(error: StakeNotDividablePreCheckError): Observable<string> {
        const exampleStakes = error.exampleStakes.map((s) => this.moneyService.transform(s)).join(` ${this.messages.common.OrSeparator} `);

        return of(`${this.messages.numpad.NotMultiple} ${exampleStakes}...`);
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof StakeNotDividablePreCheckError;
    }
}
